<template>
  <div class="select">
    <span class="select__label">{{ label }}</span>
    <div
      class="select__body"
      :class="{ 'select__body--opened': opened }"
      @click.stop="openSelect"
    >
      <span
        class="select__current_value"
        :class="{ 'select__current_value--selected': currentValue.value }"
        >{{ currentValue.name }}
      </span>
      <svg
        class="select__arrow"
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 9L0 9.08524e-07L12 0L6 9Z" fill="#C4C4C4" />
      </svg>
      <div
        class="select__options"
        ref="optionsContainer"
        :class="{ 'select__options--visible': opened }"
      >
        <span
          class="select__option"
          v-for="option in options"
          :key="option.value"
          @click.stop="selectValue(option)"
          ref="singleOption"
        >
          {{ option.label }}
        </span>
      </div>
      <CTooltip :action="show_tooltip" :position="tooltip_position">{{
        tooltip
      }}</CTooltip>
    </div>
  </div>
</template>

<script>
import CTooltip from "./CTooltip";
export default {
  name: "CSelect",
  components: { CTooltip },
  props: [
    "label",
    "options",
    "blank",
    "selected",
    "tooltip",
    "tooltip_action",
    "tooltip_position"
  ],
  data() {
    return {
      currentValue: {
        name: this.blank,
        value: null
      },
      opened: false,
      valid: null,
      show_tooltip: this.tooltip_action
    };
  },
  mounted() {
    if (!!this.tooltip === false) {
      this.show_tooltip = false;
    }
  },
  methods: {
    close() {
      this.opened = false;
      this.$refs.optionsContainer.style.maxHeight = ``;
    },
    outerClickHandler() {
      this.close();
      document.removeEventListener("click", this.outerClickHandler);
    },
    openSelect() {
      this.show_tooltip = false;
      if (this.opened) return;
      this.opened = true;
      let height = this.$refs.singleOption[0].offsetHeight;
      this.$refs.optionsContainer.style.maxHeight = `${height *
        this.$refs.singleOption.length}px`;
      document.addEventListener("click", this.outerClickHandler);
    },
    selectValue(option) {
      this.$emit("input", option.value);
      this.$emit("valid");

      this.$emit("change", option.value);

      if (this.selected === true) {
        this.currentValue = {
          name: option.label,
          value: option.value
        };
      } else {
        this.currentValue = {
          name: this.blank,
          value: null
        };
      }

      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  margin-bottom: 15px;
  position: relative;
  &__label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    display: inline-block;
  }
  &__body {
    border: 1px solid #cccccc;
    border-radius: 5px;
    padding: 11px 16px;
    position: relative;
    transition: all 200ms ease;
    &--opened {
      border-bottom-color: transparent;
      border-left-color: #3479cc;
      border-top-color: #3479cc;
      border-right-color: #3479cc;
      border-radius: 5px 5px 0 0;
    }
  }
  &__current_value {
    color: #cccccc;
    font-size: 16px;
    &--selected {
      color: #000000;
    }
  }
  &__arrow {
    position: absolute;
    top: 18px;
    right: 15px;
  }
  &__options {
    position: absolute;
    top: 100%;
    left: -1px;
    right: 0;
    width: 290px;
    background: #f4f4f4;
    display: flex;
    flex-direction: column;
    border-radius: 0 0 5px 5px;
    border-left: 1px solid #3479cc;
    border-right: 1px solid #3479cc;
    border-bottom: 1px solid #3479cc;
    z-index: 1;
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 200ms ease, opacity 0ms linear;
    &--visible {
      opacity: 1;
    }
  }
  &__option {
    transition: all 200ms ease;
    padding: 11px 16px;
    cursor: pointer;
    &:hover {
      background: #ffffff;
    }
  }
}
</style>
